<template>
  <div>
    <b-modal
        v-model="showModalInternal"
        id="product-or-category-select-modal-form"
        scrollable
        :title="title || 'Baza centralnych towarów i kategorii'"
        title-class="font-18"
        size="xl"
        style="z-index:100010!important;"
        hide-footer
    >
      <div v-if="showModalInternal">
        <ul class="nav nav-tabs">
          <li class="nav-item common-tab">
            <a :class="productsTabClass" aria-current="page" @click="openTab('PRODUCTS')">Towary</a>
          </li>
          <li class="nav-item common-tab">
            <a :class="categoriesTabClass" @click="openTab('CATEGORIES')">Kategorie</a>
          </li>
        </ul>
        <div class="row top-space">
          <div v-if="currentTab === 'PRODUCTS'">
            <ProductDataList ref="productDataList"
                             :multiselect="multiselect" @onSelect="selectProducts"
                             :showRowActions="showRowActions"
                             :showMassActions="showMassActions"
                             :selectedProducts="selectedProductsData"
                             :showAddButton="showAddButton"
                             :disableInitiallyCheckedItems="disableInitiallyCheckedItems"
                             :ignoreInitiallyCheckedItems="ignoreInitiallyCheckedItems"
                             :visibleColumnsFilter="visibleColumnsFilter"
                             :enableRowSelection="enableRowSelection"
                             :showCheckboxColumn="showCheckboxColumn"

            >
              <template #bottom>
                <div class="modal-footer-container">
                  <div class="modal-footer-bottom">
                    <button class="btn btn-primary" @click="applySelectProduct" :disabled="!selectedProducts || selectedProducts.length === 0">{{ okTitle }}</button>
                  </div>
                </div>
              </template>
            </ProductDataList>
          </div>
          <div v-else-if="currentTab === 'CATEGORIES'">
            <ProductCategoriesDataList
                ref="categoriesDataList"
                :multiselect="multiselect"
                @onSelect="selectCategories"
                :showRowActions="true"
                :showMassActions="showMassActions"
                :selectedCategoriesData="selectedCategoriesData"
                :showAddButton="showAddButton"
                :disableInitiallyCheckedItems="disableInitiallyCheckedItems"
                :ignoreInitiallyCheckedItems="ignoreInitiallyCheckedItems"
                :visibleColumnsFilter="['actions',...visibleColumnsFilter]"
                :enableRowSelection="enableRowSelection"
                :showCheckboxColumn="showCheckboxColumn"
                :visibleActionsFilter="['open-subcategories','show-products-in-category']"
                :displayInBootstrapRow="true"
            >
              <template #bottom>
                <div class="modal-footer-container">
                  <div class="modal-footer-bottom">
                    <button class="btn btn-primary" @click="applySelectCategory" :disabled="!selectedCategories || selectedCategories.length === 0">{{ okTitle }}</button>
                  </div>
                </div>
              </template>
            </ProductCategoriesDataList>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {defineComponent} from 'vue'
import {BModal} from 'bootstrap-vue-next'
import ProductDataList from './ProductDataList.vue'
import ProductCategoriesDataList from '@/views/DrugstoreCommonManager/ProductCategoriesDataList.vue'

export default defineComponent({
  name: 'ProductOrCategoryTabsModal',
  components: {BModal, ProductDataList, ProductCategoriesDataList },
  props: {
    showModal: { type: Boolean, required: true },
    title: { type: String, default: 'Baza centralnych towarów i kategorii' },
    multiselect: { type: Boolean, default: true },
    showMassActions: { type: Boolean, default: () => true },
    showRowActions: { type: Boolean, default: () => true },
    showAddButton: { type: Boolean, default: () => true },
    selectedProductsData: { type: Array, default: () => [] },
    selectedCategoriesData: { type: Array, default: () => [] },
    okTitle: { type: String, default: 'Wybierz' },
    resetSelectionAfterApply: { type: Boolean, default: () => false },
    disableInitiallyCheckedItems: { type: Boolean, default: () => false },
    ignoreInitiallyCheckedItems: {type: Boolean, default: () => false},
    visibleColumnsFilter:{ // declare only columns keys You want to see
      type:Array,
      default: ()=>[]
    },
    enableRowSelection: {
      type: Boolean,
      default: () => true
    },
    showCheckboxColumn: {
      type: Boolean,
      default: () => true
    },
  },
  emits: ['update:showModal','onApply','onApplyProducts','onApplyCategories','onClose'],
  data(){
    return {
      showModalInternal: this.showModal,
      currentTab: 'PRODUCTS',
      productsTabClass: 'nav-link active',
      categoriesTabClass: 'nav-link',
      selectedProducts: null,
      selectedCategories: null,
    }
  },
  methods: {
    openTab(tab){
      this.currentTab = tab
      if (tab === 'PRODUCTS'){
        this.productsTabClass = 'nav-link active'
        this.categoriesTabClass = 'nav-link'
      } else {
        this.productsTabClass = 'nav-link'
        this.categoriesTabClass = 'nav-link active'
      }
    },
    selectProducts(itemsData){
      this.selectedProducts = itemsData
    },
    selectCategories(itemsData){
      this.selectedCategories = itemsData
    },

    applySelectProduct(){
      this.$emit('onApplyProducts', this.selectedProducts)
      this.$emit('onApply', { type: 'PRODUCTS', items: this.selectedProducts })
      if(this.resetSelectionAfterApply && this.$refs.productDataList && this.$refs.productDataList.resetSelectedProducts){
        this.selectedProducts = null
        this.$refs.productDataList.resetSelectedProducts()
      }
    },
    applySelectCategory(){
      this.$emit('onApplyCategories', this.selectedCategories)
      this.$emit('onApply', { type: 'CATEGORIES', items: this.selectedCategories })
      if(this.resetSelectionAfterApply && this.$refs.categoriesDataList && this.$refs.categoriesDataList.resetSelectedCategories){
        this.selectedCategories = null
        this.$refs.categoriesDataList.resetSelectedCategories()
      }
    },
    closeModal(){
      this.showModalInternal = false
      this.$emit('onClose')
    }
  },
  watch:{
    showModal(newValue){
      this.showModalInternal = newValue
    },
    showModalInternal(newValue){
      this.$emit('update:showModal', newValue)
    }
  }
})
</script>

<style scoped>
.top-space { margin-top: 20px; }
.common-tab{ cursor: pointer; }
.modal-footer-container { position: sticky; bottom: -19px; left: 0; width: 100%; background: #fff; z-index: 60; padding: 0; }
.modal-footer-bottom { display: flex; justify-content: flex-end; gap: 12px; padding: 18px 24px; }
</style>
